import api from '../store/apiClient';

/**
 * Optional PLP facet rail. Many deployments do not mount `GET /public/browse-tags` yet (404).
 * @returns {Promise<Array<{ _id: string, slug: string, name: string, imageUrl?: string, sortOrder?: number }>>}
 */
export async function getPublicBrowseTagsForCategory(categorySlugOrId) {
  const key = String(categorySlugOrId || '').trim();
  if (!key) return [];
  try {
    const { data } = await api.get('/public/browse-tags', { params: { category: key } });
    const payload = data?.data !== undefined ? data.data : data;
    return Array.isArray(payload) ? payload : [];
  } catch (e) {
    const status = e?.response?.status;
    if (status === 404 || status === 501) return [];
    throw e;
  }
}
